<template>

    <div>
        <v-row no-gutters>
            <base-header>
                <div slot="page-header">Symbol Info</div>
            </base-header>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" lg="6" xl="6">
                <base-card color="primary">
                    <div slot="card-header">
                        <v-list-item three-line>
                            <v-list-item-avatar tile size="80"> <img src="../../assets/images/coin/ada.png">
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <div class="text-overline ">
                                    ADA
                                </div>
                                <v-list-item-title class="subtitle-1 ">
                                    $1.45
                                </v-list-item-title>
                                <v-list-item-subtitle>Cartano
                                </v-list-item-subtitle>
                            </v-list-item-content>


                        </v-list-item>


                    </div>
                    <div slot="card-body">
                        <v-expansion-panels flat focusable>
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <template v-slot:default="{ open }">
                                        <v-row no-gutters>
                                            <v-col cols="4">
                                                <v-chip class="ma-2 primary" label>
                                                    Rank #6
                                                </v-chip>

                                            </v-col>
                                            <v-col cols="8" class="text--secondary">
                                                <v-fade-transition leave-absolute>
                                                    <span v-if="open" key="0">
                                                        <v-chip class="ma-2 primary" label>
                                                            Volume / Market Cap 0.0488
                                                        </v-chip>

                                                    </span>
                                                    <span v-else key="1">
                                                        {{ trip.name }}
                                                    </span>
                                                </v-fade-transition>
                                            </v-col>
                                        </v-row>
                                    </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-card-text>
                                        <v-row align="center" class="mx-0">
                                            <v-rating :value="4.5" color="amber" dense half-increments readonly
                                                size="14"></v-rating>

                                            <div class="grey--text ms-4">
                                                4.5 (413)
                                            </div>
                                        </v-row>

                                        <div class="my-4 text-subtitle-1">
                                            $ • 1,67
                                        </div>

                                        <div>The live Cardano price today is $1.67 USD with a 24-hour trading volume of
                                            $2,722,626,061 USD. We update our ADA to USD price in real-time. Cardano is
                                            down 0.49% in the last 24 hours. The current CoinMarketCap ranking is #6,
                                            with a live market cap of $55,796,586,057 USD. It has a circulating supply
                                            of 33,313,246,915 ADA coins and a max. supply of 45,000,000,000 ADA coins.
                                        </div>
                                    </v-card-text>
                                </v-expansion-panel-content>
                            </v-expansion-panel>


                        </v-expansion-panels>
                    </div>
                </base-card>
            </v-col>
          <v-col cols="12" lg="6" xl="6">
                <base-card color="primary">
                    <div slot="card-header">
                        <v-list-item three-line>
                            <v-list-item-avatar tile size="80"> <img src="../../assets/images/coin/avalanche.png">
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <div class="text-overline ">
                                    AVAx
                                </div>
                                <v-list-item-title class="subtitle-1 ">
                                    $117.73
                                </v-list-item-title>
                                <v-list-item-subtitle>Avalanche
                                </v-list-item-subtitle>
                            </v-list-item-content>


                        </v-list-item>


                    </div>
                    <div slot="card-body">
                        <v-expansion-panels flat focusable>
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <template v-slot:default="{ open }">
                                        <v-row no-gutters>
                                            <v-col cols="4">
                                                <v-chip class="ma-2 primary" label>
                                                    Rank #11
                                                </v-chip>

                                            </v-col>
                                            <v-col cols="8" class="text--secondary">
                                                <v-fade-transition leave-absolute>
                                                    <span v-if="open" key="0">
                                                        <v-chip class="ma-2 primary" label>
                                                            Volume / Market Cap 0.07628
                                                        </v-chip>

                                                    </span>
                                                    <span v-else key="1">
                                                        {{ trip.name }}
                                                    </span>
                                                </v-fade-transition>
                                            </v-col>
                                        </v-row>
                                    </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-card-text>
                                        <v-row align="center" class="mx-0">
                                            <v-rating :value="4.5" color="amber" dense half-increments readonly
                                                size="14"></v-rating>

                                            <div class="grey--text ms-4">
                                                4.5 (413)
                                            </div>
                                        </v-row>

                                        <div class="my-4 text-subtitle-1">
                                            $ • 1,67
                                        </div>

                                        <div>The live Avalanche price today is $118.96 USD with a 24-hour trading volume
                                            of $2,031,356,448 USD. We update our AVAX to USD price in real-time.
                                            Avalanche is up 1.90% in the last 24 hours. The current CoinMarketCap
                                            ranking is #11, with a live market cap of $26,629,138,379 USD. It has a
                                            circulating supply of 223,844,092 AVAX coins and a max. supply of
                                            720,000,000 AVAX coins.


                                        </div>
                                    </v-card-text>
                                </v-expansion-panel-content>
                            </v-expansion-panel>


                        </v-expansion-panels>
                    </div>
                </base-card>
            </v-col>

        </v-row>
        <v-row no-gutters>
          <v-col cols="12" lg="6" xl="6">
                <base-card color="primary">
                    <div slot="card-header">
                        <v-list-item three-line>
                            <v-list-item-avatar tile size="80"> <img src="../../assets/images/coin/bat.png">
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <div class="text-overline ">
                                    BAT
                                </div>
                                <v-list-item-title class="subtitle-1 ">
                                    $1.50

                                </v-list-item-title>
                                <v-list-item-subtitle>Basic Attention Token
                                </v-list-item-subtitle>
                            </v-list-item-content>


                        </v-list-item>


                    </div>
                    <div slot="card-body">
                        <v-expansion-panels flat focusable>
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <template v-slot:default="{ open }">
                                        <v-row no-gutters>
                                            <v-col cols="4">
                                                <v-chip class="ma-2 primary" label>
                                                    Rank #72
                                                </v-chip>

                                            </v-col>
                                            <v-col cols="8" class="text--secondary">
                                                <v-fade-transition leave-absolute>
                                                    <span v-if="open" key="0">
                                                        <v-chip class="ma-2 primary" label>
                                                            Volume / Market Cap 0.7005
                                                        </v-chip>

                                                    </span>
                                                    <span v-else key="1">
                                                        {{ trip.name }}
                                                    </span>
                                                </v-fade-transition>
                                            </v-col>
                                        </v-row>
                                    </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-card-text>
                                        <v-row align="center" class="mx-0">
                                            <v-rating :value="4.5" color="amber" dense half-increments readonly
                                                size="14"></v-rating>

                                            <div class="grey--text ms-4">
                                                4.5 (413)
                                            </div>
                                        </v-row>

                                        <div class="my-4 text-subtitle-1">
                                            $ • 1,67
                                        </div>

                                        <div>The live Basic Attention Token price today is $1.47 USD with a 24-hour
                                            trading volume of $1,532,546,957 USD. We update our BAT to USD price in
                                            real-time. Basic Attention Token is up 29.02% in the last 24 hours. The
                                            current CoinMarketCap ranking is #72, with a live market cap of
                                            $2,187,785,813 USD. It has a circulating supply of 1,492,503,789 BAT coins
                                            and a max. supply of 1,500,000,000 BAT coins.
                                        </div>
                                    </v-card-text>
                                </v-expansion-panel-content>
                            </v-expansion-panel>


                        </v-expansion-panels>
                    </div>
                </base-card>
            </v-col>
          <v-col cols="12" lg="6" xl="6">
                <base-card color="primary">
                    <div slot="card-header">
                        <v-list-item three-line>
                            <v-list-item-avatar tile size="80"> <img src="../../assets/images/coin/bnb.png">
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <div class="text-overline ">
                                    BNB
                                </div>
                                <v-list-item-title class="subtitle-1 ">
                                    $1.45
                                </v-list-item-title>
                                <v-list-item-subtitle>Binance Coin
                                </v-list-item-subtitle>
                            </v-list-item-content>


                        </v-list-item>


                    </div>
                    <div slot="card-body">
                        <v-expansion-panels flat focusable>
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <template v-slot:default="{ open }">
                                        <v-row no-gutters>
                                            <v-col cols="4">
                                                <v-chip class="ma-2 primary" label>
                                                    Rank #6
                                                </v-chip>

                                            </v-col>
                                            <v-col cols="8" class="text--secondary">
                                                <v-fade-transition leave-absolute>
                                                    <span v-if="open" key="0">
                                                        <v-chip class="ma-2 primary" label>
                                                            Volume / Market Cap 0.0488
                                                        </v-chip>

                                                    </span>
                                                    <span v-else key="1">
                                                        {{ trip.name }}
                                                    </span>
                                                </v-fade-transition>
                                            </v-col>
                                        </v-row>
                                    </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-card-text>
                                        <v-row align="center" class="mx-0">
                                            <v-rating :value="4.5" color="amber" dense half-increments readonly
                                                size="14"></v-rating>

                                            <div class="grey--text ms-4">
                                                4.5 (413)
                                            </div>
                                        </v-row>

                                        <div class="my-4 text-subtitle-1">
                                            $ • 1,67
                                        </div>

                                        <div>The live Cardano price today is $1.67 USD with a 24-hour trading volume of
                                            $2,722,626,061 USD. We update our ADA to USD price in real-time. Cardano is
                                            down 0.49% in the last 24 hours. The current CoinMarketCap ranking is #6,
                                            with a live market cap of $55,796,586,057 USD. It has a circulating supply
                                            of 33,313,246,915 ADA coins and a max. supply of 45,000,000,000 ADA coins.
                                        </div>
                                    </v-card-text>
                                </v-expansion-panel-content>
                            </v-expansion-panel>


                        </v-expansion-panels>
                    </div>
                </base-card>
            </v-col>

        </v-row>
        <v-row no-gutters>
          <v-col cols="12" lg="6" xl="6">
                <base-card color="primary">
                    <div slot="card-header">
                        <v-list-item three-line>
                            <v-list-item-avatar tile size="80"> <img src="../../assets/images/coin/btc.png">
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <div class="text-overline ">
                                    BTC
                                </div>
                                <v-list-item-title class="subtitle-1 ">


                                    $58,893.45
                                </v-list-item-title>
                                <v-list-item-subtitle>Bitcoin
                                </v-list-item-subtitle>
                            </v-list-item-content>


                        </v-list-item>


                    </div>
                    <div slot="card-body">
                        <v-expansion-panels flat focusable>
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <template v-slot:default="{ open }">
                                        <v-row no-gutters>
                                            <v-col cols="4">
                                                <v-chip class="ma-2 primary" label>
                                                    Rank #1
                                                </v-chip>

                                            </v-col>
                                            <v-col cols="8" class="text--secondary">
                                                <v-fade-transition leave-absolute>
                                                    <span v-if="open" key="0">
                                                        <v-chip class="ma-2 primary" label>
                                                            Volume / Market Cap 0.0488
                                                        </v-chip>

                                                    </span>
                                                    <span v-else key="1">
                                                        {{ trip.name }}
                                                    </span>
                                                </v-fade-transition>
                                            </v-col>
                                        </v-row>
                                    </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-card-text>
                                        <v-row align="center" class="mx-0">
                                            <v-rating :value="4.5" color="amber" dense half-increments readonly
                                                size="14"></v-rating>

                                            <div class="grey--text ms-4">
                                                4.5 (413)
                                            </div>
                                        </v-row>

                                        <div class="my-4 text-subtitle-1">
                                            $ • 1,67
                                        </div>

                                        <div>The live Bitcoin price today is $58,893.45 USD with a 24-hour trading
                                            volume of $34,822,604,748 USD. We update our BTC to USD price in real-time.
                                            Bitcoin is up 1.12% in the last 24 hours. The current CoinMarketCap ranking
                                            is #1, with a live market cap of $1,112,100,452,744 USD. It has a
                                            circulating supply of 18,883,262 BTC coins and a max. supply of 21,000,000
                                            BTC coins.
                                        </div>
                                    </v-card-text>
                                </v-expansion-panel-content>
                            </v-expansion-panel>


                        </v-expansion-panels>
                    </div>
                </base-card>
            </v-col>
          <v-col cols="12" lg="6" xl="6">
                <base-card color="primary">
                    <div slot="card-header">
                        <v-list-item three-line>
                            <v-list-item-avatar tile size="80"> <img src="../../assets/images/coin/ltc.png">
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <div class="text-overline ">
                                    LTC
                                </div>
                                <v-list-item-title class="subtitle-1 ">


                                    $221.36

                                </v-list-item-title>
                                <v-list-item-subtitle>Litecoin

                                </v-list-item-subtitle>
                            </v-list-item-content>


                        </v-list-item>


                    </div>
                    <div slot="card-body">
                        <v-expansion-panels flat focusable>
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <template v-slot:default="{ open }">
                                        <v-row no-gutters>
                                            <v-col cols="4">
                                                <v-chip class="ma-2 primary" label>
                                                    Rank #15
                                                </v-chip>

                                            </v-col>
                                            <v-col cols="8" class="text--secondary">
                                                <v-fade-transition leave-absolute>
                                                    <span v-if="open" key="0">
                                                        <v-chip class="ma-2 primary" label>
                                                            Volume / Market Cap 0.0488
                                                        </v-chip>

                                                    </span>
                                                    <span v-else key="1">
                                                        {{ trip.name }}
                                                    </span>
                                                </v-fade-transition>
                                            </v-col>
                                        </v-row>
                                    </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-card-text>
                                        <v-row align="center" class="mx-0">
                                            <v-rating :value="4.5" color="amber" dense half-increments readonly
                                                size="14"></v-rating>

                                            <div class="grey--text ms-4">
                                                4.5 (413)
                                            </div>
                                        </v-row>

                                        <div class="my-4 text-subtitle-1">
                                            $ • 1,67
                                        </div>

                                        <div>The live Litecoin price today is $221.51 USD with a 24-hour trading volume
                                            of $2,210,753,217 USD. We update our LTC to USD price in real-time. Litecoin
                                            is up 2.54% in the last 24 hours. The current CoinMarketCap ranking is #15,
                                            with a live market cap of $15,296,273,101 USD. It has a circulating supply
                                            of 69,054,057 LTC coins and a max. supply of 84,000,000 LTC coins.
                                        </div>
                                    </v-card-text>
                                </v-expansion-panel-content>
                            </v-expansion-panel>


                        </v-expansion-panels>
                    </div>
                </base-card>
            </v-col>

        </v-row>
        <v-row no-gutters>
            <v-col cols="12" lg="6" xl="6">
                <base-card color="primary">
                    <div slot="card-header">
                        <v-list-item three-line>
                            <v-list-item-avatar tile size="80"> <img src="../../assets/images/coin/dogecoin.png">
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <div class="text-overline ">
                                    DOGE
                                </div>
                                <v-list-item-title class="subtitle-1 ">
                                    $0.2194
                                </v-list-item-title>
                                <v-list-item-subtitle>Dogecoin
                                </v-list-item-subtitle>
                            </v-list-item-content>


                        </v-list-item>


                    </div>
                    <div slot="card-body">
                        <v-expansion-panels flat focusable>
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <template v-slot:default="{ open }">
                                        <v-row no-gutters>
                                            <v-col cols="4">
                                                <v-chip class="ma-2 primary" label>
                                                    Rank #10
                                                </v-chip>

                                            </v-col>
                                            <v-col cols="8" class="text--secondary">
                                                <v-fade-transition leave-absolute>
                                                    <span v-if="open" key="0">
                                                        <v-chip class="ma-2 primary" label>
                                                            Volume / Market Cap 0.0488
                                                        </v-chip>

                                                    </span>
                                                    <span v-else key="1">
                                                        {{ trip.name }}
                                                    </span>
                                                </v-fade-transition>
                                            </v-col>
                                        </v-row>
                                    </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-card-text>
                                        <v-row align="center" class="mx-0">
                                            <v-rating :value="4.5" color="amber" dense half-increments readonly
                                                size="14"></v-rating>

                                            <div class="grey--text ms-4">
                                                4.5 (413)
                                            </div>
                                        </v-row>

                                        <div class="my-4 text-subtitle-1">
                                            $ • 1,67
                                        </div>

                                        <div>The live Dogecoin price today is $0.219937 USD with a 24-hour trading
                                            volume of $1,187,606,609 USD. We update our DOGE to USD price in real-time.
                                            Dogecoin is up 1.09% in the last 24 hours. The current CoinMarketCap ranking
                                            is #10, with a live market cap of $29,089,597,358 USD. It has a circulating
                                            supply of 132,263,430,955 DOGE coins and the max. supply is not available.


                                        </div>
                                    </v-card-text>
                                </v-expansion-panel-content>
                            </v-expansion-panel>


                        </v-expansion-panels>
                    </div>
                </base-card>
            </v-col>
          <v-col cols="12" lg="6" xl="6">
                <base-card color="primary">
                    <div slot="card-header">
                        <v-list-item three-line>
                            <v-list-item-avatar tile size="80"> <img src="../../assets/images/coin/link.png">
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <div class="text-overline ">
                                    LINK
                                </div>
                                <v-list-item-title class="subtitle-1 ">
                                    $26.28

                                </v-list-item-title>
                                <v-list-item-subtitle>Chainlink
                                </v-list-item-subtitle>
                            </v-list-item-content>


                        </v-list-item>


                    </div>
                    <div slot="card-body">
                        <v-expansion-panels flat focusable>
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <template v-slot:default="{ open }">
                                        <v-row no-gutters>
                                            <v-col cols="4">
                                                <v-chip class="ma-2 primary" label>
                                                    Rank #20
                                                </v-chip>

                                            </v-col>
                                            <v-col cols="8" class="text--secondary">
                                                <v-fade-transition leave-absolute>
                                                    <span v-if="open" key="0">
                                                        <v-chip class="ma-2 primary" label>
                                                            Volume / Market Cap 0.0488
                                                        </v-chip>

                                                    </span>
                                                    <span v-else key="1">
                                                        {{ trip.name }}
                                                    </span>
                                                </v-fade-transition>
                                            </v-col>
                                        </v-row>
                                    </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-card-text>
                                        <v-row align="center" class="mx-0">
                                            <v-rating :value="4.5" color="amber" dense half-increments readonly
                                                size="14"></v-rating>

                                            <div class="grey--text ms-4">
                                                4.5 (413)
                                            </div>
                                        </v-row>

                                        <div class="my-4 text-subtitle-1">
                                            $ • 1,67
                                        </div>

                                        <div>The live Chainlink price today is $26.28 USD with a 24-hour trading volume
                                            of $991,235,139 USD. We update our LINK to USD price in real-time. Chainlink
                                            is up 0.86% in the last 24 hours. The current CoinMarketCap ranking is #20,
                                            with a live market cap of $12,274,807,262 USD. It has a circulating supply
                                            of 467,009,554 LINK coins and a max. supply of 1,000,000,000 LINK coins.


                                        </div>
                                    </v-card-text>
                                </v-expansion-panel-content>
                            </v-expansion-panel>


                        </v-expansion-panels>
                    </div>
                </base-card>
            </v-col>

        </v-row>
    </div>
</template>

<script>
    import BaseCard from "../../components/Base/BaseCard.vue";
    import BaseHeader from "../../components/Base/BaseHeader.vue";


    export default {
        components: {
            BaseCard,
            BaseHeader

        },
        data: () => ({
            date: null,
            trip: {
                name: '',
                location: null,
                start: null,
                end: null,
            },
            locations: ['Australia', 'Barbados', 'Chile', 'Denmark', 'Ecuador', 'France'],
        }),
    }
</script>